Wee.fn.make('addresses', {
	init: function() {
		Wee.commerce.initSameAddressToggle();
		Wee.validate.bindFields();

		$.history.bind({
			submit: 'ref:form'
		}, {
			begin: function() {
				return Wee.validate.isValid({
					scrollTop: 'ref:form'
				});
			}
		});
	},
	unload: function() {
		Wee.commerce.destroySameAddressToggle();
		Wee.validate.destroy();
	}
});